import Menu from '@mui/material/Menu';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useMutation } from '@apollo/client';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';

import { UPDATE_SKILL_STATUS } from '../../apis/epic';
import ProjectContext from '../../context/ProjectContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';

const propTypes = {
  status: PropTypes.string,
  epicSkillData: PropTypes.oneOfType([PropTypes.object]),
  onChange: PropTypes.func,
};

const defaultProps = {
  status: '',
  epicSkillData: {},
  onChange: () => {},
};

const CustomRadio = (props) => (
  <Radio
    disableRipple
    checkedIcon={<CheckCircleIcon sx={{ color: '#2E72F6', padding: '0' }} />}
    icon={<RadioButtonUncheckedIcon sx={{ display: 'none' }} />}
    {...props}
  />
);

const ProgressMenu = (props) => {
  const { selectedListItem, showVersionHistoryBar, readOnlyMode } = useProjectVersionHistory();
  const { startDate, dispatch } = useContext(ProjectContext);
  const { status, epicSkillData, onChange } = props;

  // states
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(status);
  const [showImage, setShowImage] = useState(false);

  // constants
  const open = Boolean(anchorEl);
  const params = useParams();
  const isHidden = showVersionHistoryBar && readOnlyMode && selectedListItem !== null && selectedListItem !== undefined;

  // mutations/queries
  const [updateSkillStatus] = useMutation(UPDATE_SKILL_STATUS);

  const handleClick = (event) => {
    setShowImage(!showImage);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = async (event) => {
    const { sprint } = epicSkillData;
    setValue(event.target.value);
    onChange(event.target.value);
    const variables = {
      input: {
        epicId: epicSkillData.data.epicId,
        projectId: parseInt(params.id, 10),
        skillId: epicSkillData.data[`${sprint}_skillId`],
        status: event.target.value,
      },
    };
    await updateSkillStatus({
      variables,
    });
    await dispatch({
      type: 'SET_PROJECT_DETAIL',
      payload: {
        startDate,
        duration: 0,
      },
    });
    setAnchorEl(null);
  };

  return (
    <>
      <KeyboardArrowRightIcon
        sx={{
          color: '#344054',
          backgroundColor: '#EAECF0',
          borderRadius: '50%',
          cursor: 'pointer',
          width: '20px',
          height: '20px',
          display: isHidden ? 'none' : '',
        }}
        onClick={handleClick}
      />
      <Menu
        className="status-list-dropdown"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            border: '1px solid #D0D5DD',
            boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.12)',
            borderRadius: '2px !important',
            width: '180px',
            marginLeft: '17px',
            marginTop: '-35px',
          },
        }}
      >
        <FormControl sx={{ width: '100%' }}>
          <RadioGroup
            sx={{ width: '100%' }}
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel
              value="Not Started"
              control={<CustomRadio />}
              label="Not Started"
              labelPlacement="start"
            />
            <FormControlLabel
              value="In Progress"
              control={<CustomRadio />}
              label="In Progress"
              labelPlacement="start"
            />
            <FormControlLabel
              value="Blocked"
              control={<CustomRadio />}
              label="Blocked"
              labelPlacement="start"
            />
            <FormControlLabel
              value="Done"
              control={<CustomRadio />}
              label="Done"
              labelPlacement="start"
            />
          </RadioGroup>
        </FormControl>
      </Menu>
    </>
  );
};

ProgressMenu.propTypes = propTypes;
ProgressMenu.defaultProps = defaultProps;
export default ProgressMenu;
